import {Component, Injector, ViewChild} from '@angular/core';
import {SearchPage} from '@twpub/core/models/wrappers/search-page';
import {ComponentCategory} from '@twpub/core/enums';
import {SearchPageDirective} from './search-page.directive';
import {BaseWrapperComponent} from '@twpub/shared/components/base';

@Component({
  selector: 'pub-search-wrapper-page',
  template: '<ng-template pubSearchPage></ng-template>',
  standalone: true,
  imports: [SearchPageDirective]
})
export class SearchPageWrapperComponent extends BaseWrapperComponent<SearchPage> {
  override compCategory = ComponentCategory.SearchPage;

  @ViewChild(SearchPageDirective, {static: true}) pubSearchPage!: SearchPageDirective

  constructor(injector: Injector) {
    super(injector);
    this.logColored('----SearchPage starts rendering----');
  }

  private logColored(message: string, color: string = 'blue') {
    console.debug(`%c${message}`, `color: ${color}; font-weight: bold;`);
  }

  getViewContainerRef() {
    return this.pubSearchPage.viewContainerRef;
  }

  override createComponent(): SearchPage {
    const comp = super.createComponent();
    comp.config = this.componentConfig;
    comp.compCategory = this.compCategory;
    return comp;
  }
}
